import { render, staticRenderFns } from "./adminProduct.vue?vue&type=template&id=ea28b292"
import script from "./adminProduct.vue?vue&type=script&lang=js"
export * from "./adminProduct.vue?vue&type=script&lang=js"
import style0 from "./adminProduct.vue?vue&type=style&index=0&id=ea28b292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports